module.exports = __webpack_public_path__ + "static/media/img-130.02553daf.jpg";